import script from "./WorkflowCMC.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowCMC.vue?vue&type=script&setup=true&lang=ts"

import "./WorkflowCMC.vue?vue&type=style&index=0&id=5a784f8e&lang=scss"

const __exports__ = script;

export default __exports__